import { createRouter, createWebHistory } from "vue-router";
import { createNavigationGuards } from "./guards";
import { routes } from "./routes";

const router = createRouter({
  history: createWebHistory(),
  routes,
});
createNavigationGuards(router);
export default router;
